//工具栏功能权限id-对应后端返回的发音人speakerFeature属性(括号中是后端表存的name)
export const SPEAKER_FEATURE_IDS = {
    SLABEL_PREVIEW : 0 ,// 试听
    SLABEL_POLYPHONE : 1,//多音字
    SLABEL_DIGITAL : 2,//数字符号
    SLABEL_CONTINUOUS : 3,//连读
    SLABEL_ALIAS : 4,//别名
    SLABEL_ENGLISH : 5,//音标（英文发音）
    SLABEL_SPEED : 6,//局部变速
    SLABEL_SPEAKER : 7,//多发音人
    SLABEL_RHYTHM : 8,//停顿调节
    SLABEL_MUTE : 9,//插入静音
    SLABEL_SPECIAL : 10,//音效(特效音)
    SLABEL_BGM : 11,//配乐(背景音)
    SLABEL_PARAGRAPH_MUTE : 12,//段落静音(全局段落静音)
    SLABRL_RHOTIC_ACCENT:13,//儿化音
    SLABRL_TONE_SANDHI:14,//变调
    SLABEL_GLOBAL_SYMBOL : 15,//符号静音
    SLABEL_GLOBAL_STAY : 16,//解说模式(全文停顿调节)
    SLABEL_CONVERSION : 17,//局部变音(声音转换)
    SLABEL_FIND : 18,//批量替换(查找替换-多音字)
    SLABEL_STRESSREAD : 19,//重读
    SLABEL_DRAGSOUND : 20,//拖音
    SLABEL_SEE_SPELL : 21,//查看拼音
    SLABEL_SENSITIVE : 22,//敏感词
    SLABEL_STRESSR_DRAG : 23,//重音+拖音
    SLABEL_SYMBOL_MUTE:24,//智能分句(粗粒度)
    SLABEL_COMMENT : 99,//评论
}
//工具栏权限ID -与发音人无关
export const TOOLIST = {
    SLABEL_GLOBAL_VOULME:25
}
